var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92,
    height: 162,
    viewBox: "0 0 92 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H92V110H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-825 -256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(825 308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-2",
    "data-name": "Clip 2",
    d: "M0,0H92V110H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M60.241,110H48.85V74.809h11.39Zm-13.716,0H35.334V74.809H46.525ZM32.931,72.617H0V37.057A16.129,16.129,0,0,1,4.822,25.522a16.578,16.578,0,0,1,23.287,0,16.129,16.129,0,0,1,4.822,11.534ZM92,72.608H35.152V37.057a18.483,18.483,0,0,0-9.864-16.312H39.966V38.878h2.126V0H57.846V7.949L49.423,9.616V20.745h26.1a16.449,16.449,0,0,1,11.648,4.777A16.121,16.121,0,0,1,92,37.057Z",
    fill: "#002452"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-2",
    "data-name": "Fill 1",
    d: "M9.52,0V16.506H0L14,34h0L28,16.506H18.48V0Z",
    transform: "translate(857 256)",
    fill: "#ffb512"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBox);
export default __webpack_public_path__ + "static/media/mailBox.a04498f2d2e8c9963a5d20600f9a140a.svg";
export { ForwardRef as ReactComponent };